import React from 'react';
// STYLES
import cellStyles from '../../../../CellStyles.module.css';

const BestPriceBadge = () => {
    return <div className={cellStyles['best-price-section']}>Mejor precio</div>;
};

export default BestPriceBadge;
